import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BciShapesComponent } from './bci-shapes/bci-shapes.component';
import { HeaderComponent } from './header/header.component';
import { GooglemapsComponent } from './googlemaps/googlemaps.component';
import { GoogleMapsModule } from '@angular/google-maps';
import {
  BciSpinnerModule,
  BciWkButtonModule,
  BciWkModalModule,
  BciTableModule,
  BciWkCheckboxModule
} from '@bci/webkitbci';
import { ModalComponent } from './modal/modal.component';
import { ContentWarningComponent } from './content-warning/content-warning.component';
import { RouterModule } from '@angular/router';
import { ModalEliminarDataComponent } from './modal-eliminar-date/modal-eliminar-data.component';
import { ModalCodeWrongComponent } from './modal-code-wrong/modal-code-wrong.component';
import { ModalTimeoutComponent } from './modal-timeout/modal-timeout.component';
import { CountdownComponent } from 'src/app/components/countdown/countdown.component';
import { ModalRedirectComponent } from './modal-redirect/modal-redirect.component';
import { ModalWarningComponent } from './modal-warning/modal-warning.component';
import { ModalDateWarningComponent } from './modal-date-warning/modal-date-warning.component';
import { ModalTieneAgendaComponent } from './modal-tiene-agenda/modal-tiene-agenda.component';
import { BtnOpinionComponent } from './btn-opinion/btn-opinion.component';
import { ModalGeneralErrorComponent } from './modal-general-error/modal-general-error.component';
import { ModalNoInternetComponent } from './modal-no-internet/modal-no-internet.component';
import { ModalCambiaSucursalComponent } from './modal-cambia-sucursal/modal-cambia-sucursal.component';
import { StepperContainerComponent } from './stepper-container/stepper-container.component';
import { StickyFooterComponent } from './sticky-footer/sticky-footer.component';
import { ModalNoVisitsComponent } from './modal-no-visits/modal-no-visits.component';
import { PipesModule } from '../pipes/pipes.module';
import { LoadPurposesComponent } from './load-purposes/load-purposes.component';


@NgModule({
  declarations: [
    BciShapesComponent,
    HeaderComponent,
    GooglemapsComponent,
    ModalComponent,
    ContentWarningComponent,
    ModalEliminarDataComponent,
    ModalCodeWrongComponent,
    ModalTimeoutComponent,
    CountdownComponent,
    ModalRedirectComponent,
    ModalWarningComponent,
    ModalDateWarningComponent,
    ModalTieneAgendaComponent,
    BtnOpinionComponent,
    ModalGeneralErrorComponent,
    ModalNoInternetComponent,
    ModalCambiaSucursalComponent,
    StepperContainerComponent,
    StickyFooterComponent,
    ModalNoVisitsComponent,
    LoadPurposesComponent,

  ],
  imports: [
    BciSpinnerModule,
    CommonModule,
    GoogleMapsModule,
    BciWkModalModule,
    BciWkButtonModule,
    BciTableModule,
    BciWkCheckboxModule,
    RouterModule,
    PipesModule,
  ],
  exports: [
    BciShapesComponent,
    HeaderComponent,
    GooglemapsComponent,
    CountdownComponent,
    StepperContainerComponent,
    StickyFooterComponent,
    LoadPurposesComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ComponentsModule {}
